import { render, staticRenderFns } from "./salesStat.vue?vue&type=template&id=be84a2ec&scoped=true&"
import script from "./salesStat.vue?vue&type=script&lang=js&"
export * from "./salesStat.vue?vue&type=script&lang=js&"
import style0 from "./salesStat.vue?vue&type=style&index=0&id=be84a2ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be84a2ec",
  null
  
)

component.options.__file = "salesStat.vue"
export default component.exports